// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"513":"14b94abe","748":"f245d301"}[chunkId] || chunkId) + "." + {"279":"66671dec3c7caa89","513":"a11dc8bd15e0754d","748":"ff9b03c57f5d6af8","910":"7894f895a3053bc3"}[chunkId] + ".js";
};